"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function ColorLeft(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M10 3.999c.236 0 .475.009.714.025C16.003 4.392 20 9.005 20 14.306v.693a2 2 0 0 1-2 2h-3a2 2 0 0 0-2 2v3a2 2 0 0 1-2 2h-.694c-5.3 0-9.913-3.998-10.281-9.287A10 10 0 0 1 9.998 3.999zm0 2c-2.242 0-4.32.904-5.853 2.545a7.936 7.936 0 0 0-2.128 6.029c.288 4.163 3.928 7.426 8.287 7.426H11v-3c0-2.206 1.793-4 4-4h3v-.693c0-4.358-3.262-7.998-7.427-8.287a8.534 8.534 0 0 0-.574-.02zm-2 10A2 2 0 1 0 8 20 2 2 0 0 0 8 16m-3.5-4A1.5 1.5 0 1 0 4.5 15 1.5 1.5 0 0 0 4.5 12m10-3a1.5 1.5 0 1 0 0 3.001A1.5 1.5 0 0 0 14.5 9m-8-1A1.5 1.5 0 1 0 6.5 11 1.5 1.5 0 0 0 6.5 8m4-1A1.5 1.5 0 1 1 10.497 10 1.5 1.5 0 0 1 10.5 7zM23.534.292a1.003 1.003 0 0 1 0 1.414l-2.121 2.121 2.12 2.121a1 1 0 0 1-1.414 1.414l-2.827-2.828a1 1 0 0 1 0-1.414L22.12.292a1 1 0 0 1 1.414 0z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = ColorLeft;
